import axios from 'axios';
import Vue from 'vue';

const axiosInstance = axios.create({
        baseURL: process.env.VUE_APP_API_PATH,
		
})

axiosInstance.interceptors.request.use(
	(config) => {
            
            config.headers = {Authorization: "Bearer " + Vue.dmAuth.getToken()};		
            return config
	}, (error) => {
            console.log('request failed')
            return Promise.reject(error)
    }
)

export default axiosInstance
